<template>
  <!--
    We need the wrapper div so Vue can manage this component (e.g. for v-if or v-show) while keeping it
    separate from all the jQuery stuff that redactor does with the textarea.
    If we don't do this, the textarea stays around after redactor's destroy method finishes,
    even if there's a v-if condition that evaluates to false.
  -->
  <div><textarea v-model="innerValue" ref="textarea"></textarea></div>
</template>

<script>
  import 'vendor/redactor/redactor.js'
  import 'vendor/redactor/redactor.css'

  const createRedactorSettings = (defaults, cssClass, callbacks) => {
    return _.defaults({}, defaults, {
      // plugins: ['ssAccessibility', 'counter', 'ssIndent'],
      linkify: false,
      toolbarFixed: false,
      toolbarOverflow: true,
      pasteInlineTags: ['strong', 'b', 'u', 'em', 'i'],
      tabKey: false,
      callbacks: (() => {
        let init = _.isFunction(callbacks.init) ? callbacks.init : _.noop
        return _.assign({}, callbacks, {
          init () {
            this.$editor.addClass(cssClass)
            // this.opts.videoContainerClass = 'flex-video'
            // this.opts.modal.link = linkModal
            return init.call(this)
          },
          paste: (html) => {
            return html.replace(/&nbsp;/g, " ")
          }
        })
      })()
    })
  }

  export default {
      name: 'redactor',
      props: {
        value: String,
        config: {
          type: Object,
          default () { return {} }
        },
        mode: String,
        autoFocus: Boolean
      },
      data () {
        return {
          innerValue: this.value
        }
      },
      mounted () {
        let self = this
        let options = createRedactorSettings(this.config, $(this.$el).attr('class'), {
            change: (html) => {
              self.$emit('input', html)
            }
          })
        this.instance = $(this.$refs['textarea']).redactor(options)
        this.innerValue = (this.value || "").replace(/li\svalue=\"\d*\"/g, "li")
        if (this.autoFocus) {
          this.instance.redactor('focus.end')
        }
      },
      beforeDestroy () {
        try {
          this.instance.redactor("core.destroy")
        }
        catch (e) { }
      }
    }
</script>

<style lang="scss" scoped>

  @import "~globals";

  /deep/ .redactor {
    &-toolbar {
      background:#f5f5f5; box-shadow:none;
      li {
        a {
          color:rgba($color-black, .6);
          &:hover {
            background:none; color:$color-black;
          }
          &.redactor-act {
            background:$color-gray-darker; color:$color-white;
          }
          &.re-button-icon {
            padding:1.5rem;
          }
        }
      }
      i {
        margin:0;
      }
    }
    &-layer {
      padding:2rem 2rem 4rem; max-height:30rem; overflow:auto; word-wrap:break-word;
      @include media(medium) {
        height:40rem;
      }
      &.redactor--expand {
        max-height:none;
        @include media(medium) {
          height:initial; min-height:20rem !important;
        }
      }
    }
  }
  // #redactor-modal {
  //   @include font-primary;
  //   border-radius:0;
  //   section {
  //     padding:0;
  //   }
  //   label input {
  //     display:initial;
  //   }
  //   #redactor-modal-header {
  //     display:none;
  //   }
  //   #redactor-modal-body {
  //     @include text-medium;
  //     padding:0;
  //     .definition {
  //       float:right;
  //     }
  //   }
  //   #redactor-modal-button-cancel, #redactor-modal-button-action {
  //     @include button;
  //     @include font-primary;
  //   }
  //   #redactor-modal-button-cancel {
  //     @include button-color(transparent);
  //   }
  //   #redactor-modal-button-action {
  //     background-color:$orange !important;
  //   }
  //   #redactor-modal-close {
  //     @include position(absolute, 2.5rem 2.5rem null null);
  //     font-size:0; margin:0; z-index:1;
  //     &:before {
  //       @include icon('\e814');
  //       @include font-size(2rem,1px);
  //       position:relative; display:block; color:$gray; top:2rem;
  //     }
  //   }
  //   &-overlay {
  //     background-color:rgba($color-black, .5);
  //   }
  // }

</style>



// WEBPACK FOOTER //
// src/components/_global/redactor.vue